import { render, staticRenderFns } from "./VoucherCrud.vue?vue&type=template&id=985a0b98&scoped=true"
import script from "./VoucherCrud.vue?vue&type=script&lang=js"
export * from "./VoucherCrud.vue?vue&type=script&lang=js"
import style0 from "./VoucherCrud.vue?vue&type=style&index=0&id=985a0b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985a0b98",
  null
  
)

export default component.exports